import React, { ReactElement, useState } from "react"
import { Popup } from "semantic-ui-react"
import { CarriersName, KeeperCarrier } from "types/carrier.types"
import DHLLogo from "assets/carriers/DHL.png"
import RelaisColisLogo from "assets/carriers/RelaisColis.png"
import UPSLogo from "assets/carriers/UPS.png"
import ColissionLogoSolo from "assets/carriers/logo-solo/Colissimo.png"
import { CarrierIdChip, CarrierIdText } from "./CarriersExternalId.styled"
import { CarrierLogo } from "./AllowedCarriers.styled"

function CarriersExternalId({ carrier }: { carrier: KeeperCarrier }): ReactElement | null {
  const [isCopied, setIsCopied] = useState(false)

  if (!carrier.externalId) {
    return null
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(carrier.externalId || "")
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1000)
  }

  return (
    <Popup
      content={isCopied ? "Copié ✅" : "Clic pour copier"}
      size="small"
      position="bottom center"
      trigger={
        <CarrierIdChip onClick={handleCopy}>
          {
            {
              [CarriersName.COLISSIMO]: <CarrierLogo src={ColissionLogoSolo} size="mini" width={"12px"} />,
              [CarriersName.DHL]: <CarrierLogo src={DHLLogo} size="mini" width={"24px"} />,
              [CarriersName.RELAISCOLIS]: <CarrierLogo src={RelaisColisLogo} size="mini" width={"12px"} />,
              [CarriersName.UPS]: <CarrierLogo src={UPSLogo} size="mini" width={"12px"} />,
            }[carrier.carrierName as CarriersName]
          }
          <CarrierIdText>{carrier.externalId}</CarrierIdText>
        </CarrierIdChip>
      }
    />
  )
}
export default CarriersExternalId
